"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CaseDetailv2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ui_components_1 = require("@codametrix/ui-components");
var ui_common_1 = require("@codametrix/ui-common");
var window_open_args_1 = require("./window-open-args");
// shared-views
var case_status_1 = require("../case-status/case-status");
var case_prop_accessor2_1 = require("../case-prop-accessor/case-prop-accessor2");
var case_note_1 = require("../case-note/case-note");
// svgs
var dataURIs = __importStar(require("./_data-uris"));
var dashboard_action_bar_1 = require("../case-action-bar/dashboard-action-bar");
var icon_header_1 = require("./icon-header");
var patient_encounterv2_1 = require("../patient-encounter/patient-encounterv2");
var invoice_1 = require("../transactions/invoice/invoice");
var conditional_1 = require("../conditional/conditional");
var verdigris_1 = require("@codametrix/verdigris");
var notes_navbarv2_1 = require("../notes-sidebar/notes-navbarv2");
var timeline_1 = require("../timeline/timeline");
var svg_icons_1 = require("../svgs/svg-icons");
var invoice_meta_1 = require("../transactions/invoice/invoice-meta");
var react_2 = require("@chakra-ui/react");
var theme_1 = __importDefault(require("../../theme"));
var invoice_sources_transform_1 = require("./invoice-sources/invoice-sources-transform");
var completeSet = ui_common_1.cmxArtifacts.artifactSets.completeSet, isSingleSelection = ui_common_1.cmxArtifacts.isSingleSelection, getFeatureForSelection = ui_common_1.cmxArtifacts.getFeatureForSelection, isMultipleSelection = ui_common_1.cmxArtifacts.isMultipleSelection;
var expandedProps = new Set([
    'procedure_type',
    'ordering_provider_name',
    'ordering_provider_number.number',
    'order_number.number',
    'date_of_service',
    'place_of_service',
    'tenant_name',
    'billing_provider_name',
    'billing_provider_number.number',
    'visit_number.number',
    'case_id'
]);
var expandedAmplifyProps = new Set([
    'accession',
    'exam_code',
    'exam_description',
    'reason_for_visit'
]);
var getStatusTimestamp = function (caseRun, stages) {
    var _a;
    if (caseRun.case_completed_datetime) {
        return ui_common_1.cmxDateTime.format(caseRun.case_completed_datetime, ui_common_1.cmxDateTime.FORMATS.DATE_TIME_WITH_ZONE);
    }
    if (stages.length) {
        var stage = __spreadArray([], __read(stages), false).reverse().pop();
        return ui_common_1.cmxDateTime.format((_a = stage === null || stage === void 0 ? void 0 : stage.displayDate.raw) !== null && _a !== void 0 ? _a : new Date(), ui_common_1.cmxDateTime.FORMATS.DATE_TIME_WITH_ZONE);
    }
    return 'N/A';
};
var conditionalUtils = ui_common_1.AmplifyCore.conditionalUtils;
var CaseDetailv2 = /** @class */ (function (_super) {
    __extends(CaseDetailv2, _super);
    function CaseDetailv2(props) {
        var _this = _super.call(this, props) || this;
        _this.noteRefs = {};
        _this._handleToggleClick = _this._handleToggleClick.bind(_this);
        _this._onFeatureSelection = _this._onFeatureSelection.bind(_this);
        _this._handleOpenJson = _this._handleOpenJson.bind(_this);
        _this._handleProcessIdChange = _this._handleProcessIdChange.bind(_this);
        _this._handleGroupedCaseClick = _this._handleGroupedCaseClick.bind(_this);
        _this._handlePatientExpansion = _this._handlePatientExpansion.bind(_this);
        _this.onFeatureActivation = _this.onFeatureActivation.bind(_this);
        var showAllArtifacts = completeSet.size === props.artifactSet.size;
        _this._artifactRef = react_1["default"].createRef();
        _this._noteRef = react_1["default"].createRef();
        _this._patientRef = react_1["default"].createRef();
        _this.props.setActiveNote(_this.props.notes[0]);
        _this.state = {
            expandEncounter: false,
            openClaims: [],
            backHover: false,
            showAllArtifacts: showAllArtifacts,
            expandDemographicsPanel: true,
            demographicsLocation: 'right'
        };
        return _this;
    }
    CaseDetailv2.prototype.componentDidMount = function () {
        var _a;
        // CQA-UI: hide side nav bar
        this.props.hideSideNavBar();
        var _b = ((_a = this.props.match) !== null && _a !== void 0 ? _a : {}).params, params = _b === void 0 ? {} : _b;
        if (this.props.mode !== 'code-edit') {
            this.props.onNavigate(params.id, true, params.serviceLine);
        }
        return;
    };
    CaseDetailv2.prototype.componentDidUpdate = function () {
        var _this = this;
        this.props.notes.forEach(function (note) {
            _this.noteRefs[note.document_id] = react_1["default"].createRef();
        });
    };
    CaseDetailv2.prototype._handleGroupedCaseClick = function (ev) {
        var _a;
        ev.preventDefault();
        var target = ev.target || document.createElement('div');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
        if (!linkable)
            return;
        var item = linkable.attributes.getNamedItem('data-case-id');
        if (!item)
            return;
        var caseId = item.value;
        if (!caseId)
            return;
        // assume all grouped cases will be in the same service line
        var _b = ((_a = this.props.match) !== null && _a !== void 0 ? _a : {}).params, params = _b === void 0 ? {} : _b;
        this.props.onNavigate(caseId, undefined, params.serviceLine);
    };
    CaseDetailv2.prototype._onFeatureSelection = function (selection) {
        var _a, _b, _c, _d, _e;
        if (selection.display) {
            if (isMultipleSelection(selection)) {
                var spanSelector = ".qa-".concat(selection.code.uuid);
                var targetElement = (_a = document
                    .querySelector(spanSelector)) === null || _a === void 0 ? void 0 : _a.closest('.accordion-section');
                if (targetElement) {
                    (_c = (_b = this._artifactRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.scrollToElement(targetElement);
                }
            }
            else if (isSingleSelection(selection)) {
                var feature = getFeatureForSelection(selection);
                var inExpanded = expandedProps.has(feature.field);
                this._patientRef.current.expandEncounter(inExpanded);
                if (inExpanded) {
                    var state = __assign(__assign({}, this.state), { expandEncounter: true });
                    this.setState(state);
                }
                else if (feature.field === 'raw_body') {
                    var _f = __read(feature.spans, 1), selectedSpan = _f[0];
                    var spanSelector = ".span-".concat(selectedSpan.uuid);
                    var targetElement = document.querySelector(spanSelector);
                    if (targetElement) {
                        (_e = (_d = this._noteRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.scrollToElement(targetElement);
                    }
                }
            }
        }
        this.props.onFeatureSelection(selection);
    };
    CaseDetailv2.prototype.onFeatureActivation = function (selection) {
        var _a, _b;
        // only pop open the accordion for active selections
        if (!selection.selectionState.active && selection.evidence.length === 1) {
            var state = __assign({}, this.state);
            var _c = __read(selection.evidence, 1), firstEvidence_1 = _c[0];
            var claimMatcher = function (claim) {
                return !(claim.fieldIdentifier === firstEvidence_1.fieldIdentifier &&
                    claim.fieldName === firstEvidence_1.fieldName);
            };
            state.openClaims = state.openClaims.filter(claimMatcher);
            state.expandEncounter = state.openClaims.length > 0;
            this.setState(state);
            this._patientRef.current.expandEncounter(state.expandEncounter);
        }
        else if (selection.selectionState.active) {
            var _d = __read(selection.evidence, 1), selectedSpan = _d[0];
            var fieldName = selectedSpan.fieldName;
            if (fieldName === 'body') {
                var spanSelector = ".span-".concat(selectedSpan.hash);
                var targetElement = document.querySelector(spanSelector);
                if (targetElement) {
                    (_b = (_a = this._noteRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.scrollToElement(targetElement);
                }
            }
            else {
                var inExpanded = new Set(__spreadArray(__spreadArray([], __read(expandedProps), false), __read(expandedAmplifyProps), false)).has(fieldName);
                if (inExpanded) {
                    var state = __assign(__assign({}, this.state), { expandEncounter: true });
                    state.openClaims = __spreadArray(__spreadArray([], __read(state.openClaims), false), [
                        {
                            fieldIdentifier: selectedSpan.fieldIdentifier,
                            fieldName: selectedSpan.fieldName
                        }
                    ], false);
                    this.setState(state);
                    this._patientRef.current.expandEncounter(state.expandEncounter);
                }
            }
        }
        this.props.onFeatureActivation(selection);
    };
    CaseDetailv2.prototype._handlePatientExpansion = function (isOpen) {
        this.setState(__assign(__assign({}, this.state), { expandEncounter: isOpen }));
    };
    CaseDetailv2.prototype._handleToggleClick = function (event) {
        event.preventDefault();
        var showAllArtifacts = !this.state.showAllArtifacts;
        this.props.toggleArtifacts(showAllArtifacts);
        this.setState(__assign(__assign({}, this.state), { showAllArtifacts: showAllArtifacts }));
    };
    CaseDetailv2.prototype._handleOpenJson = function (event) {
        var _a, _b, _c, _d, _e;
        event.preventDefault();
        var activeItem = this.props.activeItem;
        var serviceLineConfig = ui_common_1.appServiceLines.determineServiceLineConfig({
            name: activeItem.service_line,
            caseIdentifier: "".concat(activeItem.case_uid || activeItem.case_id)
        });
        var caseId = serviceLineConfig.caseIdProp in activeItem
            ? activeItem[serviceLineConfig.caseIdProp]
            : activeItem.case_id;
        var isStandalone = this.props.activeItem.case_type === ui_common_1.commonEnums.UIModesEnum.STANDALONE;
        var params = { caseId: caseId };
        var target = (_a = event.currentTarget) === null || _a === void 0 ? void 0 : _a.closest('.icon-button');
        if (target && this.props.activeItem.case_id) {
            var validTarget = target;
            var href = "".concat((_b = validTarget === null || validTarget === void 0 ? void 0 : validTarget.dataset.href) !== null && _b !== void 0 ? _b : '');
            var base = void 0;
            params.processInstanceId = this.props.activeItem.process_instance_id;
            params.serviceLine = (_e = (_d = (_c = this.props.match) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.serviceLine) !== null && _e !== void 0 ? _e : '';
            if (href.indexOf('import-amplify') !== -1) {
                this.props.onCaseAction({
                    action: 'import-amplify',
                    caseRun: this.props.activeItem,
                    caseOrganizationContext: this.props.caseOrganizationContext
                });
            }
            else if (href.indexOf('launch-amplify') !== -1 && isStandalone) {
                // STANDALONE case same window
                var serviceLineConfig_1 = ui_common_1.appServiceLines.determineServiceLineConfig({
                    name: this.props.activeItem.service_line,
                    caseIdentifier: "".concat(activeItem.case_uid || activeItem.case_id)
                });
                var caseId_1 = serviceLineConfig_1.caseIdProp in activeItem
                    ? activeItem[serviceLineConfig_1.caseIdProp]
                    : activeItem.case_id;
                if (this.props.loadAllPatientDetailOptions) {
                    this.props.loadAllPatientDetailOptions(this.props.tenantId);
                }
                // CQA-UI: pass hasAmplifyCaseRunV2Access argument to openAmplifyCase
                this.props.openAmplifyCase({
                    serviceLine: this.props.activeItem.service_line,
                    caseId: caseId_1,
                    id: this.props.activeItem.process_instance_guid,
                    hasAmplifyCaseRunV2Access: this.props.hasAmplifyCaseRunV2Access
                });
            }
            else {
                //Dashboard Icon Button Menu
                params.managed = true;
                if (href.indexOf('bpm-steps') !== -1) {
                    base = window_open_args_1.bpmStepsPopup;
                    params.processInstanceId = this.props.activeItem.process_instance_id;
                }
                else if (href.indexOf('json-view') !== -1) {
                    base = window_open_args_1.caseDetailPopup;
                }
                else if (href.indexOf('launch-amplify') !== -1) {
                    // PLAYGROUND case new window
                    base = window_open_args_1.launchAmplifyPopup;
                    params.launchpoint = 'Automate';
                    params.processInstanceGuid = this.props.activeItem.process_instance_guid;
                    params.processInstanceGuids = this.props.items
                        .map(function (item) { return "".concat(item.case_id, ":").concat(item.process_instance_guid); })
                        .join(',');
                }
                else if (href.indexOf('case-documents') != -1) {
                    base = window_open_args_1.caseDocumentsPopup;
                }
                this.props.openChildWindow(__assign(__assign({}, base), { params: params }));
            }
        }
    };
    CaseDetailv2.prototype._handleProcessIdChange = function (event) {
        event.preventDefault();
        var target = event.target || document.createElement('div');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
        if (!linkable)
            return;
        var item = linkable.attributes.getNamedItem('data-process-id');
        if (!item)
            return;
        var processId = parseInt(item.value);
        if (!processId)
            return;
        var caseRuns = Object.values(this.props.caseRuns).flat();
        var soughtRun = caseRuns.find(function (caseRun) { return caseRun.process_instance_id === processId; });
        if (!soughtRun)
            return;
        this.props.setActiveProcess({
            caseRun: soughtRun,
            serviceLine: this.props.serviceLine
        });
    };
    CaseDetailv2.prototype.handleDemographicsPanelClick = function (ev) {
        ev.preventDefault();
        this.setState({
            expandDemographicsPanel: !this.state.expandDemographicsPanel
        });
    };
    CaseDetailv2.prototype.handleDemographicsLocationClick = function (ev, location) {
        ev.preventDefault();
        this.setState({
            demographicsLocation: location
        });
    };
    CaseDetailv2.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        var _x = this.props, artifactLoadState = _x.artifactLoadState, artifactSet = _x.artifactSet, activeItem = _x.activeItem, codeEdits = _x.codeEdits, loadState = _x.loadState, notes = _x.notes, artifactList = _x.artifactList, codeDescriptions = _x.codeDescriptions, formErrors = _x.formErrors, groupedCases = _x.groupedCases, caseRuns = _x.caseRuns, roles = _x.roles, stages = _x.stages, codeEditingPanel = _x.codeEditingPanel, propertyConfig = _x.propertyConfig, activations = _x.activations, simplifiedInvoices = _x.simplifiedInvoices, caseEdits = _x.caseEdits, organization = _x.organization, capability = _x.capability, mode = _x.mode, htmlNotes = _x.htmlNotes, noteUnavailableReason = _x.noteUnavailableReason, documentMetadata = _x.documentMetadata, updateValue = _x.updateValue, updateCase = _x.updateCase, setActiveNote = _x.setActiveNote, processInstance = _x.processInstance, activeNote = _x.activeNote, flagList = _x.flagList, coderNotesCapability = _x.coderNotesCapability, displayTopLeftPatientInfo = _x.displayTopLeftPatientInfo, workItem = _x.workItem;
        var onVerticalMiniTabSelection = function (selection) {
            _this.props.setActiveVerticalMiniTab(selection.displayName);
        };
        var onDocumentSelect = function (doc) { return __awaiter(_this, void 0, void 0, function () {
            var noteRef, newActiveNote;
            return __generator(this, function (_a) {
                noteRef = this.noteRefs[doc.documentId];
                requestAnimationFrame(function () {
                    var _a;
                    return (_a = noteRef === null || noteRef === void 0 ? void 0 : noteRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest' //Sets horizontal alignment
                    });
                });
                newActiveNote = notes.find(function (note) { return note.document_id === doc.documentId; });
                if (newActiveNote) {
                    setActiveNote(newActiveNote);
                }
                return [2 /*return*/];
            });
        }); };
        var _y = this, _z = _y.state, expandEncounter = _z.expandEncounter, openClaims = _z.openClaims, actionBar = _y.props.actionBar;
        // at the moment we only support a single case run
        var dataItem = activeItem;
        var _0 = ((_a = this.props.match) !== null && _a !== void 0 ? _a : {}).params, params = _0 === void 0 ? {} : _0;
        var prop = (0, case_prop_accessor2_1.propAccessor2)(dataItem, activations.property);
        var noteStyle;
        var showLoading = loadState.loading || loadState.initial;
        if (showLoading) {
            noteStyle = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 30 }) }));
        }
        else {
            noteStyle = (0, jsx_runtime_1.jsx)(case_note_1.Notes, { notes: notes, noteRefs: this.noteRefs });
        }
        /** Start Patient details logic */
        var fieldEditorInfo = {
            caseEdits: caseEdits,
            organization: organization,
            updateValue: updateValue,
            updateCase: updateCase
        };
        var cellMaker = (0, patient_encounterv2_1.CellMaker)(prop, this.props.activeItem, fieldEditorInfo, null);
        var cellPatientMaker = (0, patient_encounterv2_1.CellPatientMaker)(prop, this.props.activeItem);
        // all info less last item
        var patientConfigDetails = (_c = (_b = this.props.propertyConfig) === null || _b === void 0 ? void 0 : _b.patient) === null || _c === void 0 ? void 0 : _c.slice(0, ((_e = (_d = this.props.propertyConfig) === null || _d === void 0 ? void 0 : _d.patient) === null || _e === void 0 ? void 0 : _e.length) - 1);
        var patientLastItem = this.props.propertyConfig.patient.slice(-1);
        // add hr less the last one item
        patientConfigDetails = patientConfigDetails.map(function (patient, index) {
            return __assign(__assign({}, patient), { addHr: index + 1 !== patientConfigDetails.length });
        });
        var topCells = patientConfigDetails.map(cellPatientMaker);
        var topRightCell = patientLastItem.map(cellMaker);
        /** End Patient details logic */
        var statusTimestamp = getStatusTimestamp(dataItem, stages);
        var loadingClasses = [{ 'loading-card': showLoading }];
        var rawArtifactLength = (_g = (_f = dataItem.artifacts) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0;
        var displayedArtifactLength = artifactList.length;
        var userIsCoder = ui_common_1.userUtils.isCoder(roles);
        var codeEditMode = this.props.mode === ui_common_1.commonEnums.CaseDetailMode.EDIT;
        var multipleArtifacts = false;
        if (!userIsCoder) {
            if (simplifiedInvoices && simplifiedInvoices.length) {
                multipleArtifacts = simplifiedInvoices.length > 0;
            }
            else {
                multipleArtifacts =
                    rawArtifactLength > displayedArtifactLength || rawArtifactLength > 0;
            }
        }
        var caseDetailClasses = [
            'case-detailv2',
            'simple-layout',
            "demographics-".concat(this.state.demographicsLocation),
            "case-".concat(this.props.mode, "-mode"),
            {
                'multiple-artifacts': multipleArtifacts,
                'encounter-expanded': expandEncounter,
                'case-detail-loading': showLoading,
                'demographics-open': this.state.expandDemographicsPanel,
                'demographics-closed': !this.state.expandDemographicsPanel
            }
        ];
        //History of code automation
        var artifactListClasses = __spreadArray(['automation-container'], __read(loadingClasses), false);
        var artifactToggle = ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "info-cell" }, { children: ["codes \u00A0", (0, jsx_runtime_1.jsx)("span", __assign({ className: "artifact-toggle" }, { children: userIsCoder ? ((0, jsx_runtime_1.jsx)("span", {})) : ((0, jsx_runtime_1.jsxs)("span", { children: ["(", (0, jsx_runtime_1.jsx)("a", __assign({ className: "qa-artifact-toggle", onClick: this._handleToggleClick, href: "#toggle-artifacts" }, { children: this.state.showAllArtifacts ? "show summary" : "show all" })), ")"] })) }))] })));
        var preGoLive = ui_common_1.caseUtils.isPreGoLive(activeItem);
        var mrn = "".concat(prop('patient_identifier.issuer', 'SRC N/A'), ": ").concat(prop('patient_identifier.number'));
        var accessionNumber = "".concat(prop('primary_clinical_identifier.number'), " src: (").concat(prop('primary_clinical_identifier.issuer'), ")");
        var providerComments = Array.from(new Set(// get unique comments with a set
        (_l = (_k = (_j = (_h = this.props) === null || _h === void 0 ? void 0 : _h.activeItem) === null || _j === void 0 ? void 0 : _j.invoices) === null || _k === void 0 ? void 0 : _k.find(function (invoice) { return invoice.type === ui_common_1.commonEnums.CaseArtifactTypes.ASSEMBLED; }) // just the ASSEMBLED invoice
        ) === null || _l === void 0 ? void 0 : _l.transactions.map(function (transaction) { var _a; return (_a = transaction === null || transaction === void 0 ? void 0 : transaction.custom_values) === null || _a === void 0 ? void 0 : _a.comment; }).filter(Boolean) // remove undefined/null comments
        ));
        var encounterHeader = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "encounter-expanders" }, { children: ["patient encounter", (0, jsx_runtime_1.jsxs)("span", __assign({ className: "show-toggle" }, { children: ["(", (0, jsx_runtime_1.jsxs)("a", __assign({ onClick: function (ev) {
                                ev.preventDefault();
                                if (expandEncounter) {
                                    openClaims = [];
                                }
                                else {
                                    openClaims = __spreadArray(__spreadArray([], __read(openClaims), false), [
                                        { fieldIdentifier: 'showToggle', fieldName: 'showToggle' }
                                    ], false);
                                }
                                _this.setState({
                                    expandEncounter: !expandEncounter,
                                    openClaims: openClaims
                                });
                            }, className: "qa-expand-encounter", href: "#/show-details" }, { children: ["show ", expandEncounter ? 'summary' : 'more'] })), ")"] }))] })));
        if (this.props.mode === 'dashboard' && !actionBar) {
            actionBar = ((0, jsx_runtime_1.jsx)(dashboard_action_bar_1.DashboardActionBar, { actionsState: this.props.actionsState, caseRun: this.props.activeItem, handleOpenJson: this._handleOpenJson, handleProcessIdChange: this._handleProcessIdChange, handleBackClick: this.props.handleBackClick, caseRuns: caseRuns }));
        }
        var charges = Array.isArray(simplifiedInvoices)
            ? simplifiedInvoices.map(function (invoice, idx) {
                var _a, _b, _c;
                return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "invoice-item-group" }, { children: [invoice.meta ? ((0, jsx_runtime_1.jsx)(invoice_meta_1.InvoiceMetaHeading, { meta: invoice.meta, onImportClick: _this._handleGroupedCaseClick })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})), (0, jsx_runtime_1.jsx)(invoice_1.Invoice, { panelActivations: activations.panel, onFeatureSelection: _this.onFeatureActivation, simplifiedInvoice: invoice, editable: false, transactionV2: conditionalUtils.capabilityValue((_c = (_b = (_a = _this.props.capabilities) === null || _a === void 0 ? void 0 : _a.capabilities) === null || _b === void 0 ? void 0 : _b.transactionV2) === null || _c === void 0 ? void 0 : _c.on) })] }), idx));
            })
            : false;
        var shouldShowAddAttachDocsButton = conditionalUtils.capabilityValue((_q = (_p = (_o = (_m = this === null || this === void 0 ? void 0 : this.props) === null || _m === void 0 ? void 0 : _m.capabilities) === null || _o === void 0 ? void 0 : _o.capabilities) === null || _p === void 0 ? void 0 : _p.attachDocs) === null || _q === void 0 ? void 0 : _q.on) &&
            this.props.UIView === ui_common_1.commonEnums.UIViewEnum.AMPLIFY &&
            this.props.UIMode === ui_common_1.commonEnums.UIModesEnum.STANDALONE &&
            ui_common_1.appServiceLines.isIPC(activeItem.service_line) &&
            this.props.editable;
        var showImprovementsCapability = codeEditMode &&
            conditionalUtils.capabilityValue((_t = (_s = (_r = this.props.capabilities) === null || _r === void 0 ? void 0 : _r.capabilities) === null || _s === void 0 ? void 0 : _s.improvements) === null || _t === void 0 ? void 0 : _t.on);
        var tabsItems = [
            {
                id: 'Notes',
                displayName: 'Notes',
                active: this.props.activeVerticalMiniTab ===
                    ui_common_1.commonEnums.MiniTabLabels.NOTES_LABEL,
                body: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "provider-comments-section" }, { children: providerComments.length > 0 &&
                                providerComments.map(function (comment, index) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "provider-comments" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "provider-comments-icon" }, { children: (0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Comments, titleText: "Provider Comments" }) })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "provider-text" }, { children: comment }))] }), "provider-comment-".concat(index))); }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "doc-nav-wrap" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "doc-nav" }, { children: (0, jsx_runtime_1.jsx)(notes_navbarv2_1.NotesNavbarv2, { onSelect: onDocumentSelect, activeNote: activeNote, documentMetadata: documentMetadata, isIPC: ui_common_1.appServiceLines.isIPC(activeItem.service_line), capabilities: this.props.capabilities.capabilities, showAddAttachDocsButton: shouldShowAddAttachDocsButton, showAttachDocsModal: function () {
                                            return _this.props.showAttachDocsModal(activeItem);
                                        } }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "documentation-section" }, { children: noteStyle }))] }))] })),
                titleText: 'Notes',
                styleName: 'tab-teal'
            },
            displayTopLeftPatientInfo && {
                id: 'relatedCases',
                displayName: ui_common_1.commonEnums.MiniTabLabels.RELATED_LABEL,
                active: this.props.activeVerticalMiniTab ===
                    ui_common_1.commonEnums.MiniTabLabels.RELATED_LABEL,
                body: this.props.relatedCasesView,
                titleText: ui_common_1.commonEnums.MiniTabLabels.RELATED_DESCRIPTION,
                styleName: 'tab-green'
            },
            showImprovementsCapability && {
                id: 'improvements',
                displayName: ui_common_1.commonEnums.MiniTabLabels.IMPROVEMENTS_LABEL,
                active: this.props.activeVerticalMiniTab ===
                    ui_common_1.commonEnums.MiniTabLabels.IMPROVEMENTS_LABEL,
                body: this.props.documentImprovementsPanel,
                titleText: ui_common_1.commonEnums.MiniTabLabels.IMPROVEMENTS_DESCRIPTION,
                styleName: 'tab-yellow'
            },
            {
                id: 'activity',
                displayName: ui_common_1.commonEnums.MiniTabLabels.ACTIVITY_LABEL,
                active: this.props.activeVerticalMiniTab ===
                    ui_common_1.commonEnums.MiniTabLabels.ACTIVITY_LABEL,
                body: (0, jsx_runtime_1.jsx)(timeline_1.Timeline, { items: this.props.activity }),
                titleText: ui_common_1.commonEnums.MiniTabLabels.ACTIVITY_DESCRIPTION,
                styleName: 'tab-orange'
            }
        ].filter(Boolean);
        if (mode === 'code-edit' &&
            ((this.props.activeItem.health_system_code === 'HFHS' &&
                this.props.activeItem.service_line === 'IPC') ||
                sessionStorage.getItem('codeSourcesFlag') === 'true')) {
            tabsItems.push({
                id: 'Code Sources',
                displayName: ui_common_1.commonEnums.MiniTabLabels.CODE_SOURCES,
                active: this.props.activeVerticalMiniTab ===
                    ui_common_1.commonEnums.MiniTabLabels.CODE_SOURCES,
                body: (0, invoice_sources_transform_1.invoiceAPInvoicesToInvoiceSources)((_v = (_u = this.props) === null || _u === void 0 ? void 0 : _u.activeItem) === null || _v === void 0 ? void 0 : _v.invoices),
                titleText: ui_common_1.commonEnums.MiniTabLabels.CODE_SOURCES_DESCRIPTION,
                styleName: 'tab-tropical-50'
            });
        }
        var toggleButton = ((0, jsx_runtime_1.jsx)(react_2.Button, __assign({ className: "demographics-toggle-button", variant: 'toggle', onClick: function (ev) { return _this.handleDemographicsPanelClick(ev); }, "data-dd-action-name": !this.state.expandDemographicsPanel
                ? '~Open Demographics V2'
                : '~Close Demographics V2' }, { children: !this.state.expandDemographicsPanel ? ((0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Chevron_Left, titleText: "Show Demographics" })) : ((0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Chevron_Right, titleText: "Collapse Demographics" })) })));
        var placementToggle = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: this.state.demographicsLocation == 'bottom' ? ((0, jsx_runtime_1.jsx)(react_2.Button, __assign({ className: "location-toggle-button", variant: 'toggle', onClick: function (ev) { return _this.handleDemographicsLocationClick(ev, 'right'); }, "data-dd-action-name": '~Pin Demographics to Right' }, { children: (0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Arrow_Right, titleText: "Pin to Right", iconSize: "12" }) }))) : ((0, jsx_runtime_1.jsx)(react_2.Button, __assign({ className: "location-toggle-button", variant: 'toggle', onClick: function (ev) { return _this.handleDemographicsLocationClick(ev, 'bottom'); }, "data-dd-action-name": '~Pin Demographics to Bottom' }, { children: (0, jsx_runtime_1.jsx)(verdigris_1.BiomeIcon, { iconName: verdigris_1.IconName.Arrow_Right, titleText: "Pin to Bottom", iconSize: "12" }) }))) }));
        var toggleButtonGroup = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: this.state.demographicsLocation == 'bottom' ? ((0, jsx_runtime_1.jsxs)(react_2.HStack, __assign({ className: "location-toggle-button-group" }, { children: [toggleButton, placementToggle] }))) : ((0, jsx_runtime_1.jsxs)(react_2.VStack, __assign({ className: "location-toggle-button-group" }, { children: [toggleButton, placementToggle] }))) }));
        return ((0, jsx_runtime_1.jsx)(react_2.ChakraProvider, __assign({ theme: theme_1["default"] }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(caseDetailClasses) }, { children: [actionBar, (formErrors === null || formErrors === void 0 ? void 0 : formErrors.status) === 'PAGE NOT FOUND' ? ((0, jsx_runtime_1.jsx)(ui_components_1.Modal, { title: 'Unable to load case (Case id# ' + params.id + ')', buttonText: 'Return', closable: false, icon: (0, jsx_runtime_1.jsx)("img", { src: dataURIs.AlertIcon, width: 30, height: 30 }), onSubmit: this.props.handleBackClick, children: (0, jsx_runtime_1.jsx)("p", { children: 'The case you are trying to view does not exist. Please check the information and try again.' }) })) : null, (0, jsx_runtime_1.jsxs)("div", __assign({ className: "left-column" }, { children: [displayTopLeftPatientInfo && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "patient-top-info-container" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "patient-info-primary sensitive-data", "data-testid": "patient-info-name" }, { children: [prop('patient_name'), (0, jsx_runtime_1.jsx)("div", __assign({ className: "patient-info-secondary" }, { children: topCells }))] })), topRightCell, (0, jsx_runtime_1.jsx)("a", __assign({ href: '#/patient-info', className: "timeline-button-container", onClick: function (ev) {
                                            ev.preventDefault();
                                            _this.props.showPatientInfo(_this.props.activeItem);
                                        } }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1.CMXIcon, { svgIconClass: "patient-timeline", svgIconName: "BiomeCalender", svgIconSize: "24", svgTitleText: "Patient Timeline" }) }))] }))), (0, jsx_runtime_1.jsx)(ui_components_1.TabbedContainer, { items: tabsItems, onSelection: onVerticalMiniTabSelection })] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "middle-column" }, { children: [!codeEditMode && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "large-status-container" }, { children: showLoading ? ((0, jsx_runtime_1.jsx)(ui_components_1.Card, __assign({ className: (0, classnames_1["default"])(__spreadArray([
                                        'status-loading'
                                    ], __read(loadingClasses), false)) }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 2 }) }))) : ((0, jsx_runtime_1.jsx)(case_status_1.CaseStatus, { onClick: this._handleGroupedCaseClick, billingGroupLoadState: this.props.billingGroupLoadState, groupedCases: groupedCases, caseRun: activeItem, timeStamp: statusTimestamp, isPreGoLive: preGoLive })) }))), codeEditingPanel || ((0, jsx_runtime_1.jsx)(ui_components_1.FlexCard, __assign({ unflexed: true, 
                                //@ts-ignore
                                ref: this._artifactRef, header: artifactLoadState.initial ? ((0, jsx_runtime_1.jsx)("span", {})) : ((0, jsx_runtime_1.jsx)(icon_header_1.IconHeader, { svgIconName: verdigris_1.IconName.Coding, svgIconClass: "card-header-icon", header: artifactToggle, svgTitleText: "Coding" })), className: (0, classnames_1["default"])(artifactListClasses) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "case-status-codes" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "prediction-section" }, { children: artifactLoadState.initial ? ((0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 2 })) : (artifactList || []).length === 0 && !charges ? ((0, jsx_runtime_1.jsxs)("h4", __assign({ className: "content-vacant" }, { children: [' ', userIsCoder ||
                                                    (activeItem.artifacts || []).length === 0
                                                    ? 'No codes available'
                                                    : 'No codes displayed'] }))) : charges ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: charges })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})) })) })) })))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "right-column" }, { children: showLoading ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 3 }), (0, jsx_runtime_1.jsx)("br", {})] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [toggleButtonGroup, (0, jsx_runtime_1.jsx)(patient_encounterv2_1.PatientEncounterv2
                                //@ts-ignore
                                , { 
                                    //@ts-ignore
                                    ref: this._patientRef, activations: activations, propertyConfig: propertyConfig, activeItem: activeItem, handleExpansion: this._handlePatientExpansion, showCoderNotesInfo: this.props.showCoderNotesInfo, showProviderInfo: this.props.showProviderInfo, fieldEditorInfo: {
                                        caseEdits: caseEdits,
                                        organization: organization,
                                        updateValue: updateValue,
                                        updateCase: updateCase
                                    }, capability: __assign(__assign({}, capability), { on: 
                                        //@ts-ignore
                                        conditionalUtils.capabilityValue(capability.on) &&
                                            mode === ui_common_1.commonEnums.CaseDetailMode.EDIT }), coderNotesCapability: coderNotesCapability, flagList: flagList, workItem: workItem, activeContext: (_w = this.props.context) === null || _w === void 0 ? void 0 : _w.activeContext })] })) }))] })) })));
    };
    CaseDetailv2.defaultProps = {
        onCaseAction: function (action) { },
        onFeatureActivation: function (selection) { },
        showCoderNotesInfo: function (coderNotesParams) { },
        items: [],
        mode: ui_common_1.commonEnums.CaseDetailMode.DASHBOARD,
        actionsState: {},
        capability: { on: conditional_1.DEFAULT_UNAVAILABLE_CAPABILITY },
        coderNotesCapability: __assign({}, ui_common_1.AmplifyCore.conditionalUtils.disabledCapability),
        noteUnavailableReason: __assign({}, ui_common_1.AmplifyCore.conditionalUtils.disabledCapability),
        flagList: [],
        activeVerticalMiniTab: ui_common_1.commonEnums.MiniTabLabels.NOTES_LABEL,
        setActiveVerticalMiniTab: function (activeTabName) { },
        propertyConfig: {
            patient: [],
            summary: [],
            expanded: []
        },
        displayTopLeftPatientInfo: true,
        editable: false
    };
    return CaseDetailv2;
}(react_1["default"].Component));
exports.CaseDetailv2 = CaseDetailv2;
//# sourceMappingURL=case-detailv2.js.map